// extracted by mini-css-extract-plugin
export default {"checkIcon":"PushInSync_checkIcon__qcdaZ"};